export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProjectDetails.vue?vue&type=template&id=48103470&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ProjectDetails.vue?vue&type=template&id=48103470&scoped=true&
// module id = 292
// module chunks = 0